import React, { useState, useEffect } from 'react';
import SnackbarContentWrapper from 'components/molecules/Snackbar/SnackbarContentWrapper';

import { makeStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
const useStyles = makeStyles((theme) => ({
  snackbarRoot: {
    zIndex: 99999,
    marginTop: 60,
  },
}));

const NewSnackbar = (props) => {
  const { open = false, onClose = (f) => f, option = {}, message = '' } = props;
  const classes = useStyles();

  const [openFleg, setOpenFleg] = useState(false);

  useEffect(() => {
    setOpenFleg(open);
  }, [open]);

  return typeof message !== 'undefined' ? (
    <Snackbar
      anchorOrigin={
        !!option.anchorOrigin
          ? option.anchorOrigin
          : {
              vertical: 'top',
              horizontal: 'center',
            }
      }
      open={openFleg}
      autoHideDuration={
        !!option.autoHideDuration ? option.autoHideDuration : 3000
      }
      onClose={onClose}
      classes={{
        root: classes.snackbarRoot,
      }}
    >
      <SnackbarContentWrapper variant={option.type} message={message} />
    </Snackbar>
  ) : null;
};

export default NewSnackbar;
